define('app',['require','exports','module','jquery','jqueryui','stacktrace','all','superfishmenu','fancyboxpack','fancyboxmedia','bootstraptab','bootstrapDatePicker','moment','ractivejs','controllermanager','services/googleanalytics','utils','services/userService','services/ractive_decorators'],function (require, exports, module) {
    'use strict';

    //top of master TODO: get jqueryui, bootstraptab, and bootstrapdatepicker into only files that depend on them, so less up front loading during development
    require('jquery');
	require('jqueryui');
	require('stacktrace');
	require('all');
	
    //bottom of resources master
	require('superfishmenu');
	require('fancyboxpack');
	require('fancyboxmedia');
	require('bootstraptab');
	require('bootstrapDatePicker');
    require('moment');

	var Ractive = require('ractivejs');
	var controllerManager = require('controllermanager');
	var googleanalytics = require('services/googleanalytics');
	var utils = require('utils');
	var userService = require('services/userService');
	var ractiveDecorators = require('services/ractive_decorators');
	//var ractiveAdaptors = require('services/ractive_adaptors');

    /**
     * "app" and "ServerData" SHOULD be the only names we put on the window
     */
    var App = function () {};

    var proto = App.prototype;

    /**
     * Set up any dependencies of the app
     * TODO: consider making the controller manager init the controller if it doesn't require server data to be loaded. Make layout.serverDataReady handler that checks the status of the layout's server data promise and adds a then handler to it...by default controller manager would assume the controller shouldn't be inited until that's done, but check for controller property "PreLoadable" or something to indicate that it can be loaded prior to Serverdata being available--that controller could of course use layout.ServerDataReady to do things once it's loaded
     */
    proto.init = function (prod) {
        this.prod = prod;
        this.setRactiveGlobals();
        googleanalytics.init();
        this.controllerManager = controllerManager.init(); //only set this, since used in vacations.js currently to load a controller...
    };

    proto.setRactiveGlobals = function() {
        Ractive.DEBUG = !this.prod;
        var helpers = Ractive.defaults.data;
        helpers.formatMoney =  utils.formatMoney.bind(utils);
        helpers.formatDate = utils.formatDate.bind(utils);
        helpers.inRole = userService.inRole;
        helpers.isLoggedIn = userService.isLoggedIn;
        helpers.isLinked = userService.isLinked;
        helpers.isNullOrWhiteSpace = utils.isNullOrWhiteSpace.bind(utils);
        Ractive.decorators = ractiveDecorators;
        //Ractive.adaptors = ractiveAdaptors;
    };

    return App;
});
